import { render, staticRenderFns } from "./PublicationsBySource.vue?vue&type=template&id=1932150e&"
import script from "./PublicationsBySource.vue?vue&type=script&lang=js&"
export * from "./PublicationsBySource.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsBySource.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports